import React, { useEffect, useState, useCallback } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Row,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Progress,
  Input,
  Spinner,
  FormGroup,
  Form,
} from "reactstrap";
import Widget from "../../components/Widget/Widget.js";
import "./table.css";

import s from "./Tables.module.scss";
import {
  API_TIMEOUT,
  PROGRESS_BANTUAN_API,
  UPDATE_KUNCI,
} from "../../utils/index.js";
import axios from "axios";
import swal from "sweetalert";
import Locked from "../../assets/locked.png";
import UnLocked from "../../assets/unlocked.png";

const TableKunci = function () {
  const [firstTable, setFirstTable] = useState([]);
  const [fullTableData, setFullTableData] = useState([]);
  const [firstTableCurrentPage, setFirstTableCurrentPage] = useState(0);
  const [simpleDropdownValue2, setSimpleDropdownValue2] = useState(String(new Date().getFullYear()));
  const [selectedDinas, setSelectedDinas] = useState("");
  const [bantuanModal, setBantuanModal] = useState("");
  const [dokumenSK, setDokumenSK] = useState("");
  const [modalSK, setModalSk] = useState(false);
  const [idKunci, setIdKunci] = useState("");
  const [kunciBan, setKunciBan] = useState("");
  const [tanggalBukaKunci, setTanggalBukaKunci] = useState("");
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);

  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const u = JSON.parse(localStorage.getItem("user"));
    if (u) {
      setCurrentUser(u);
    }
  }, []);

  const ambilProgresBantuan = useCallback((tahun) => {
    const tahunStr = String(tahun).trim();
    if (!tahunStr) return;
    setIsLoadingData(true);
    axios({
      method: "get",
      url: PROGRESS_BANTUAN_API + tahunStr,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) return;
        const data = response.data?.data ?? [];
        setFullTableData(data);
        setFirstTable(data);
      })
      .catch((error) => {
        alert(error?.message || "Gagal mengambil data");
      })
      .finally(() => setIsLoadingData(false));
  }, []);

  useEffect(() => {
    ambilProgresBantuan(simpleDropdownValue2);
  }, [simpleDropdownValue2, ambilProgresBantuan]);

  const listTahun = Array.from({ length: currentYear - 2018 + 1 }, (_, i) => ({ tahun: 2018 + i }));

  const handleTahunChange = (tahunBaru) => {
    setFullTableData([]);
    setFirstTable([]);
    setIsLoadingData(true);
    setSimpleDropdownValue2(String(tahunBaru));
    setSelectedDinas("");
    setFirstTableCurrentPage(0);
  };

  const onChange1 = (e) => setDokumenSK(e.target.files[0] || "");

  const simpanKunci = async () => {
    const formData = new FormData();
    formData.append("photo", dokumenSK);
    formData.append("bantuan", bantuanModal);
    formData.append("tahun", simpleDropdownValue2);
    formData.append("tanggalBuka", tanggalBukaKunci);
    formData.append("kunciAturan", kunciBan);

    try {
      const response = await axios.patch(UPDATE_KUNCI + idKunci, formData, {
        credentials: "include",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${""}`,
        },
      });
      if (response.data.success === 1) {
        setKunciBan("");
        setTanggalBukaKunci("");
        setDokumenSK("");
        setIdKunci("");
        setModalSk(false);
        setBantuanModal("");
        ambilProgresBantuan(simpleDropdownValue2);
        swal("Sukses", "Pengaturan bantuan berhasil diedit", "success");
      } else {
        swal("Gagal", "Pengaturan bantuan gagal diedit", "error");
      }
    } catch (err) {
      swal("Gagal", err?.message || "Pengaturan bantuan gagal diedit", "error");
    }
  };

  const openModalSk = (item) => {
    setIdKunci(item.id);
    setBantuanModal(item.bantuan);
    setKunciBan(item.kunciAturan || "");
    setTanggalBukaKunci(item.tanggalBuka || "");
    setModalSk(true);
  };

  const closeModalSk = () => {
    setIdKunci("");
    setKunciBan("");
    setTanggalBukaKunci("");
    setDokumenSK("");
    setModalSk(false);
    setBantuanModal("");
  };

  const pageSize = 100;
  const listDinas = [...new Set(firstTable.map((r) => r.dinas).filter(Boolean))].sort();
  const dataByDinas = !selectedDinas
    ? { first: firstTable }
    : { first: firstTable.filter((r) => r.dinas === selectedDinas) };
  const displayTable = dataByDinas.first;
  const firstTablePagesCount = Math.ceil(displayTable.length / pageSize);

  const setFirstTablePage = (e, index) => {
    e.preventDefault();
    setFirstTableCurrentPage(index);
  };

  return (
    <div>
      <Row>
        <Col>
          <Row className="mb-4">
            <Col>
              <Widget>
                <div className={s.tableTitle}>
                  <div className="headline-2">Pengaturan Kunci Bantuan</div>
                  <div className={s.filterRow}>
                    <div className={s.filterItem}>
                      <label className={s.filterLabel}>Tahun</label>
                      <Input
                        type="select"
                        value={simpleDropdownValue2}
                        onChange={(e) => handleTahunChange(e.target.value)}
                        className={s.filterSelect}
                      >
                        {listTahun.map((item) => (
                          <option key={item.tahun} value={item.tahun}>
                            {item.tahun}
                          </option>
                        ))}
                      </Input>
                    </div>
                    <div className={s.filterItem}>
                      <label className={s.filterLabel}>Dinas</label>
                      <Input
                        type="select"
                        value={selectedDinas}
                        onChange={(e) => {
                          setSelectedDinas(e.target.value);
                          setFirstTableCurrentPage(0);
                        }}
                        className={s.filterSelect}
                      >
                        <option value="">Semua Dinas</option>
                        {listDinas.map((d) => (
                          <option key={d} value={d}>
                            {d}
                          </option>
                        ))}
                      </Input>
                    </div>
                  </div>
                </div>
                <div
                  className={`widget-table-overflow ${s.progressTableWrap} ${s.progressInputTableMinimal} ${isLoadingData ? s.tableLoading : ""}`}
                >
                  {isLoadingData && (
                    <div className={s.tableLoadingOverlay}>
                      <Spinner color="primary" />
                      <span className={s.loadingText}>Memuat data...</span>
                    </div>
                  )}
                  {!isLoadingData && displayTable.length === 0 ? (
                    <div className={`d-flex align-items-center justify-content-center py-5 ${s.emptyTableMsg}`}>
                      <span className={s.loadingText}>Belum ada data bantuan</span>
                    </div>
                  ) : (
                    <>
                      <Table
                        className={`table-striped table-borderless table-hover ${s.statesTable}`}
                        responsive
                      >
                        <thead>
                          <tr>
                            <th className="w-10">No</th>
                            <th className="w-25">BANTUAN</th>
                            <th className="w-25">TAHUN</th>
                            <th className="w-25">DINAS</th>
                            <th className="w-25">TOTAL PENERIMA</th>
                            <th className="w-25">PROGRESS</th>
                            <th className="w-25">KUNCI</th>
                            <th className="w-25">TANGGAL BUKA</th>
                            <th className="w-25">DASAR</th>
                          </tr>
                        </thead>
                        <tbody>
                          {displayTable
                            .slice(
                              firstTableCurrentPage * pageSize,
                              (firstTableCurrentPage + 1) * pageSize
                            )
                            .map((item, idx) => (
                              <tr key={item.id || uuidv4()}>
                                <td>{firstTableCurrentPage * pageSize + idx + 1}</td>
                                <td className="d-flex align-items-center">
                                  <span className="ml-3">{item.bantuan}</span>
                                </td>
                                <td>{item.tahun}</td>
                                <td>{item.dinas}</td>
                                <td>{item.jmlPenerima}</td>
                                <td>
                                  <div className="d-flex justify-content-between">
                                    <div className="d-flex flex-column mt-3">
                                      <div className={s.activity}>
                                        <p className="body-2">
                                          {item.jmlPenerima
                                            ? Math.round((item.jumlahpenerima / item.jmlPenerima) * 100)
                                            : 0}
                                          % Input Penerima
                                        </p>
                                        <p className="body-2">
                                          {item.jumlahpenerima}
                                          <span className="body-3 muted">/{item.jmlPenerima}</span>
                                        </p>
                                      </div>
                                      <Progress
                                        color={
                                          item.jmlPenerima &&
                                          (item.jumlahpenerima / item.jmlPenerima) * 100 > 50
                                            ? "success"
                                            : "danger"
                                        }
                                        className="progress-xs"
                                        value={
                                          item.jmlPenerima
                                            ? (item.jumlahpenerima / item.jmlPenerima) * 100
                                            : 0
                                        }
                                      />
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => openModalSk(item)}
                                  >
                                    <img
                                      src={
                                        item.kunciAturan === "Ya" ? Locked : UnLocked
                                      }
                                      alt={item.kunciAturan === "Ya" ? "Terkunci" : "Terbuka"}
                                    />
                                  </div>
                                </td>
                                <td>{item.tanggalBuka || "-"}</td>
                                <td>
                                  {item.dokumenBuka ? (
                                    <a
                                      href={item.dokumenBuka}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ color: "green" }}
                                    >
                                      <i className="eva eva-file" />
                                    </a>
                                  ) : (
                                    <span className="text-muted">-</span>
                                  )}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                      <Pagination
                        className="pagination-borderless"
                        aria-label="Page navigation example"
                      >
                        <PaginationItem disabled={firstTableCurrentPage <= 0}>
                          <PaginationLink
                            onClick={(e) =>
                              setFirstTablePage(e, firstTableCurrentPage - 1)
                            }
                            previous
                            href="#top"
                          />
                        </PaginationItem>
                        {[...Array(firstTablePagesCount)].map((page, i) => (
                          <PaginationItem
                            active={i === firstTableCurrentPage}
                            key={i}
                          >
                            <PaginationLink
                              onClick={(e) => setFirstTablePage(e, i)}
                              href="#top"
                            >
                              {i + 1}
                            </PaginationLink>
                          </PaginationItem>
                        ))}
                        <PaginationItem
                          disabled={
                            firstTableCurrentPage >= firstTablePagesCount - 1
                          }
                        >
                          <PaginationLink
                            onClick={(e) =>
                              setFirstTablePage(e, firstTableCurrentPage + 1)
                            }
                            next
                            href="#top"
                          />
                        </PaginationItem>
                      </Pagination>
                    </>
                  )}
                </div>
              </Widget>
            </Col>
          </Row>
        </Col>
      </Row>

      <Modal size="md" isOpen={modalSK} toggle={() => closeModalSk()}>
        <ModalHeader toggle={() => closeModalSk()}>
          <div className="headline-2">
            {bantuanModal}
            <code> Tahun {simpleDropdownValue2}</code>
          </div>
        </ModalHeader>
        <ModalBody>
          <Widget className="widget-p-md">
            <Form onSubmit={(e) => e.preventDefault()}>
              <FormGroup row>
                <Label md={3} for="kunci-aturan" className="text-md-right">
                  Kunci Aturan
                </Label>
                <Col md={9}>
                  <Input
                    type="select"
                    id="kunci-aturan"
                    value={kunciBan}
                    onChange={(e) => setKunciBan(e.target.value)}
                  >
                    <option value="">- Pilih -</option>
                    <option value="Ya">Ya</option>
                    <option value="Tidak">Tidak</option>
                  </Input>
                </Col>
              </FormGroup>
              {kunciBan === "Tidak" && (
                <>
                  <FormGroup row>
                    <Label md={3} for="tanggal-buka" className="text-md-right">
                      Tanggal Buka Kunci
                    </Label>
                    <Col md={9}>
                      <Input
                        type="date"
                        id="tanggal-buka"
                        value={tanggalBukaKunci}
                        onChange={(e) =>
                          setTanggalBukaKunci(e.target.value)
                        }
                      />
                    </Col>
                  </FormGroup>
                  <div className="headline-2 mb-3">Upload Dokumen</div>
                  <FormGroup row>
                    <Label lg={3} className="text-md-right mt-3">
                      File input
                    </Label>
                    <Col lg={9}>
                      <div className="input-group mb-4 px-2 py-2 rounded-pill bg-light-gray">
                        <input
                          id="upload-kunci"
                          type="file"
                          accept="application/pdf"
                          onChange={onChange1}
                          className={`form-control border-0 ${s.upload}`}
                        />
                        <label
                          id="upload-label-kunci"
                          htmlFor="upload-kunci"
                          className={`font-weight-light text-muted ${s.uploadLabel}`}
                        >
                          {dokumenSK?.name || "Pilih file"}
                        </label>
                        <div className="input-group-append">
                          <label
                            htmlFor="upload-kunci"
                            className="btn btn-light m-0 rounded-pill px-4"
                          >
                            <i className="fa fa-cloud-upload mr-2 text-muted" />
                          </label>
                        </div>
                      </div>
                    </Col>
                  </FormGroup>
                </>
              )}
            </Form>
          </Widget>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={() => closeModalSk()}>
            Batal
          </Button>
          <Button color="success" onClick={() => simpanKunci()}>
            Simpan
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default TableKunci;
